// Pure, dependency-free helpers for the observe-only game_end CAPTCHA.
//
// Extracted so the decision logic (when does the final-answer token fire?) and
// the header-building logic (what config does save-answer send?) can be unit
// tested without webpack's "@/" alias or any browser globals. No imports here
// on purpose - keep it loadable by plain Node (`node --test`).

/**
 * Decide whether the game_end CAPTCHA should fire for the answer about to be
 * saved. Mirrors GamePlayView.nextQuestion()'s end condition: the LAST answer
 * of a REGULAR game, never a bonus round.
 *
 * @param {boolean} isBonusRound       - true when the current set is a bonus round.
 * @param {number}  currentQuestionNumber - 1-based index of the question being answered.
 * @param {number}  totalQuestions     - total questions in the regular game.
 * @returns {boolean} true only on the final answer of a non-bonus game.
 */
export function shouldAttachGameEnd(isBonusRound, currentQuestionNumber, totalQuestions) {
    return !isBonusRound && currentQuestionNumber >= totalQuestions;
}

/**
 * Build the axios config for save-answer. Observe-only / soft-fail: a token is
 * attached only when gameEnd is true AND a token was minted; otherwise the
 * config is undefined and the request goes out unchanged (headerless).
 *
 * @param {boolean} gameEnd - result of shouldAttachGameEnd for this answer.
 * @param {string|null} token - token from getCaptchaToken('game_end'), or null.
 * @param {string} widgetId - app-defined per-game widget id for X-Captcha-Widget.
 * @returns {{headers: object}|undefined} axios config, or undefined when no header.
 */
export function buildGameEndConfig(gameEnd, token, widgetId) {
    if (!gameEnd || !token) return undefined;
    return {headers: {"X-Captcha-Token": token, "X-Captcha-Action": "game_end", "X-Captcha-Widget": widgetId}};
}
